import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "span" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "112%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, eyebrow, title, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-baseline gap-4 mb-6">
      {index && <span className="font-mono text-xs tracking-widest text-muted-foreground">{index}</span>}
      <span className="font-mono text-xs tracking-[0.25em] uppercase text-telemetry">{eyebrow}</span>
    </div>
    <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
      {title}
    </h2>
  </Reveal>
);
